import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class AppFormControlService {

    _formUpdates = new Subject<void>();

    toFormGroup(fields: RequirementField[]) {
        const group: any = {};

        fields.forEach(field => {
            group[field.alias] = this.controlForField(field);
        });

        return new UntypedFormGroup(group);
    }

    // Notify any subscribers watching for form updates
    // they may need to update their forms.
    updateForms() {
        this._formUpdates.next();
    }

    controlForField(field: RequirementField) {
        const value: boolean | string = field.value;
        return new UntypedFormControl(value);
    }

    get formUpdates(): Observable<void> {
        return this._formUpdates.asObservable();
    }
}
